import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=e2fe8644&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=e2fe8644&scoped=true&lang=css&"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=e2fe8644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe8644",
  null
  
)

export default component.exports